import { render, staticRenderFns } from "./ForcaVendas.vue?vue&type=template&id=52372ede"
import script from "./ForcaVendas.vue?vue&type=script&lang=js"
export * from "./ForcaVendas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports